import { Calculator, Sparkles, CheckSquare, GraduationCap, LogOut } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { useAuth } from '../context/AuthContext';

const BottomNav = ({ activeTab, onTabChange }) => {
  const { t, language } = useLanguage();
  const { logout } = useAuth();
  
  const navItems = [
    { id: 'education', labelKey: 'menu.education', icon: GraduationCap },
    { id: 'tools', labelKey: 'bottomNav.tools', icon: Calculator },
    { id: 'premium', icon: Sparkles, label: 'Supreme', isHighlight: true },
    { id: 'checklist', icon: CheckSquare, label: 'Checklist' },
    { id: 'logout', icon: LogOut, label: language === 'bm' || language === 'ms' ? 'Keluar' : 'Logout', isLogout: true },
  ];

  return (
    <nav style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'var(--bg-card)',
      borderTop: '1px solid var(--border-subtle)',
      padding: '8px 0 env(safe-area-inset-bottom, 8px)',
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      zIndex: 100,
      boxShadow: '0 -2px 10px rgba(0,0,0,0.1)'
    }}>
      {navItems.map((item) => {
        const isActive = !item.isLogout && !item.isHighlight && activeTab === item.id;
        const isHighlight = item.isHighlight;
        
        return (
          <button
            key={item.id}
            onClick={() => item.isLogout ? logout() : onTabChange(item.id)}
            data-testid={`bottomnav-${item.id}`}
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: '2px',
              padding: isHighlight ? '0' : '8px 12px',
              background: 'transparent',
              border: 'none',
              cursor: 'pointer',
              color: item.isLogout ? 'var(--text-muted)' : isHighlight ? '#E01E3A' : isActive ? '#E01E3A' : 'var(--text-muted)',
              transition: 'all 0.2s ease',
              minWidth: '60px',
              position: 'relative',
              marginTop: isHighlight ? '-18px' : '0'
            }}
          >
            {isHighlight ? (
              <div style={{
                width: '52px',
                height: '52px',
                borderRadius: '50%',
                background: 'linear-gradient(135deg, #E01E3A, #C41830)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 4px 15px rgba(224, 30, 58, 0.5)',
                border: '3px solid var(--bg-card)'
              }}>
                <item.icon size={24} color="#fff" />
              </div>
            ) : (
              <div style={{
                padding: '6px',
                borderRadius: '10px',
                background: isActive ? 'rgba(224, 30, 58, 0.1)' : 'transparent',
                transition: 'all 0.2s ease'
              }}>
                <item.icon size={22} />
              </div>
            )}
            <span style={{ 
              fontSize: isHighlight ? '9px' : '10px', 
              fontWeight: isHighlight ? '700' : isActive ? '600' : '500',
              color: isHighlight ? '#E01E3A' : undefined,
              letterSpacing: isHighlight ? '0.3px' : undefined
            }}>
              {item.label || t(item.labelKey)}
            </span>
          </button>
        );
      })}
    </nav>
  );
};

export default BottomNav;
